import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import { ReactComponent as CopyrightIcon } from '../images/copyright.svg'
import '../styles/components/Footer.scss'

const Footer = (props) => {
  return (
    <div className='Footer'>
      <nav className='Footer__nav'>
        <NavLink className='Footer__nav-link' exact to='/'>Home</NavLink>
        <NavLink className='Footer__nav-link' exact to='/about'>About us</NavLink>
        <NavLink className='Footer__nav-link' exact to='/customer'>Customer Service</NavLink>
        <NavLink className='Footer__nav-link' exact to='/privacy'>Privacy Policy</NavLink>
        <NavLink className='Footer__nav-link' exact to='/contact'>Contact us</NavLink>
      </nav>
      <div className='Footer__copyright'>
        <CopyrightIcon alt='copyright' />
        <span className='Footer__copyright--text'>2019 <Link to='/'><span style={{ color: '#1b6355' }}>MedEasy</span></Link>. All Rights Reserved</span>
      </div>
    </div>
  )
}
 
export default Footer;